import React from "react";

import Link from "next/link";
import { useRouter } from "next/router";

const LINKS = [
    {
        name: "Headline partner",
        href: "/headline-partners",
    },
    {
        name: "Headline sponsor",
        href: "/headline-sponsors",
    },
    // {
    //     name: "Strategic partners",
    //     href: "/strategic-partners",
    // },
    // {
    //     name: "Strategic sponsor",
    //     href: "/strategic-sponsors",
    // },
    {
        name: "Associates",
        href: "/associates",
    },
];
function PartnersAndSponsorsLinks() {
    const router = useRouter();
    return (
        <div className='tabsNavigation'>
            <ul className='commonList'>
                {
                    LINKS.map((item, index) => (
                        <li className={router.pathname === item.href ? "active" : ""} key={index}>
                            <Link href={item.href}>{item.name}</Link>
                        </li>

                    ))
                }
            </ul>
        </div>
    );
}

export default PartnersAndSponsorsLinks;
